import { defaultCardClasses } from '@/components/ui/Card/Card';
import { cva } from 'class-variance-authority';
export var cardVariants = cva("".concat(defaultCardClasses, " group"), {
    defaultVariants: {
        layout: 'default',
    },
    variants: {
        layout: {
            default: 'flex-row md:flex-col',
            horizontal: 'flex-row md:hover:scale-[1.02]',
        },
    },
});
export var cardImageVariants = cva('group-hover:scale-[1.03] transition duration-300 bg-cover bg-center aspect-video', {
    defaultVariants: {
        layout: 'default',
    },
    variants: {
        layout: {
            default: 'max-md:w-1/2',
            horizontal: 'w-1/2',
        },
    },
});
export var cardContentContainerVariants = cva('flex flex-col p-[16px] gap-3 md:flex-1', {
    defaultVariants: {
        layout: 'default',
    },
    variants: {
        layout: {
            default: 'max-md:w-1/2',
            horizontal: 'w-1/2 md:gap-4 md:px-[30px] md:py-[40px]',
        },
    },
});
export var cardTitleContainerVariants = cva('flex flex-col gap-2 flex-1 text-neutral-800', {
    defaultVariants: {
        layout: 'default',
    },
    variants: {
        layout: {
            default: '',
            horizontal: 'md:flex-1 md:gap-3',
        },
    },
});
export var cardTitleVariants = cva('tracking-[-0.4px] leading-[1.5rem] font-bold font-sans', {
    defaultVariants: {
        layout: 'default',
    },
    variants: {
        layout: {
            default: 'sm:text-lg md:text-xl sm:leading-[1.5rem] md:leading-[1.5rem]',
            horizontal: 'sm:text-lg md:text-2xl lg:text-3xl sm:leading-[1.5rem] md:leading-[2.1rem]',
        },
    },
});
export var cardSubTitleVariants = cva('font-sans font-medium text-xs sm:text-sm', {
    defaultVariants: {
        layout: 'default',
    },
    variants: {
        layout: {
            default: '',
            horizontal: 'md:text-base',
        },
    },
});
export var cardSupportersVariants = cva('font-medium font-sans text-sm', {
    defaultVariants: {
        layout: 'default',
    },
    variants: {
        layout: {
            default: '',
            horizontal: 'sm:text-base',
        },
    },
});
